import styled from "styled-components";

export const DivMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
  height: 100%;
`;
export const DivTabs = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: flex-start;

  width: 100%;
  height: 30px;

  background-color: #eee;
`;
export const DivTab = styled.div`
  width: auto;
  height: 100%;

  padding: 8px 25px 8px 25px;

  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  cursor: pointer;
`;
/*
ant-pagination ant-table-pagination ant-table-pagination-right
*/
export const DivList = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
  align-content: flex-start;

  width: 100%;
  height: calc(100% - 60px);

  margin-bottom: 10px;
  background-color: #fff;

  padding: 0 20px;

  .ant-table-wrapper {
    width: 100%;
    height: 100%;
  }
  .ant-spin-nested-loading {
    width: 100%;
    height: 100%;
  }
  .ant-spin-container {
    width: 100%;
    height: 100%;
  }
  .ant-table {
    width: 100%;
    height: 100%;
  }
  .ant-table-container {
    width: 100%;
    height: 100%;
    overflow: auto;

    table {
      width: 100%;
    }
  }
  .ant-table-body {
    height: 100%;
    /* border: 1px solid #ddd; */
    /* td, th {
            padding: 8px;
            } */

    /* .ant-table-row-level-0{
                border-top: 1px solid #E8E8E8;
                border-bottom: 1px solid #E8E8E8;
            } */
  }
  .ant-table-header {
    height: 50px;
  }
  .ant-table-thead {
    > tr > th {
      height: 50px;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      /* font-size: 11px;
            line-height: 13px; */
      border-bottom: 0px;
    }
  }

  /* td, th {
        border: 1px solid #ddd;
        padding: 8px;
    } */

  .intelie-bold-cell {
    font-weight: bold;
  }
  .intelie-upper-text {
    text-transform: uppercase;
  }
  .ant-table-cell {
    background-color: #fff;
    color: #606a80;
    font-family: "Source Sans Pro", sans-serif;
    font-style: normal;
    /* font-size: 12px; */
    padding: 0px;

    min-height: 50px;
    min-width: 50px;
    height: 50px;

    border-bottom: 0px;

    text-align: center;
  }
  .ant-table-cell-with-append {
    font-weight: bold;
    text-align: left;

    display: flex;
    flex-direction: row;
    align-items: center;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .ant-table-cell-scrollbar {
    background-color: #fff;
    position: sticky;
    /* left: 0px; */
    right: 0px;
  }
  .ant-table-body {
    height: calc(100% - 50px);
  }

  .ant-table-row:hover {
    .ant-table-cell {
      background-color: #e1f0ff;
    }
  }
  .ant-table-row-level-0 {
    .ant-table-cell-with-append {
      font-weight: bold;
    }
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
  }
`;
export const StyleSelectedTab = {
  backgroundColor: "#fff",
  fontWeight: 600,
};

export const ExpandIcon = styled.i`
  &.blue {
    color: #37a3ef;
  }
  &.fa-chevron-up {
    justify-content: center;
    align-content: center;
    padding: 0 5px;
  }
  &.fa-chevron-down {
    justify-content: center;
    align-content: center;
    padding: 0 5px;
  }
  &.null {
    justify-content: center;
    align-content: center;
    padding: 0 10px;

    :hover {
      cursor: default;
    }
  }
`;

export const DivCell = styled.div`
  background-color: ${({ colNumber = 0 }) => {
    if (colNumber & 1) return "#EEEEEE";
    else return "#FFFFFF";
  }};

  border-bottom: ${({ leaf = false }) => {
    if (leaf) return "1px solid #E8E8E8";
    else return "0px";
  }};

  display: flex;
  width: 100%;
  height: 100%;
  line-height: 100%;

  padding: 5px 15px;
  align-content: center;
  text-align: center;
  vertical-align: middle;

  align-items: center;
  justify-content: left;
`;
